import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthLayout, PrivateLayout, SelfRegistrationLayout, UIErrorHandler } from 'common/components';
import { ERoute } from 'common/const';
import { useAppDispatch } from 'app/store/store.hooks';
import { initAuth } from 'entities/Auth/Auth.slice';

export const App: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(initAuth());
  }, []);

  return (
    <UIErrorHandler>
      <div className="app">
        <Routes>
          <Route path={ERoute.Login} element={<AuthLayout path={ERoute.Login} />} />
          <Route path={ERoute.Activation} element={<AuthLayout path={ERoute.Activation} />} />
          <Route path={ERoute.RestorePassword} element={<AuthLayout path={ERoute.RestorePassword} />} />
          <Route path={ERoute.Registration} element={<AuthLayout path={ERoute.Registration} />} />
          <Route path={ERoute.SelfRegistration} element={<SelfRegistrationLayout />} />
          <Route path="*" element={<PrivateLayout />} />
        </Routes>
      </div>
    </UIErrorHandler>
  );
};
